const ERROR_TYPES = {
    ANONYMOUS: 'anonymous',
    PROMOTION_NOT_ACTIVE: 'PROMOTION_NOT_ACTIVE',
    SEGMENT_NOT_ACTIVE: 'SEGMENT_NOT_ACTIVE',
    CUSTOMER_IS_NOT_IN_SEGMENT: 'CUSTOMER_IS_NOT_IN_SEGMENT',
    PROMOTION_NOT_FOUND: 'PROMOTION_NOT_FOUND'
};

export { ERROR_TYPES };
